// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_29-1";
export var movingGradient = "_29-4";
export var movingGradientBlock = "_29-2";
export var skeleton = "_29-0";
export var skeletonText = "_29-3";